/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box, Button, Divider, Icon, Skeleton, Theme, Typography, useMediaQuery, useTheme, alpha, SxProps, Avatar,  Chip} from "@mui/material";
import { Description } from "@mui/icons-material";
interface IFerramentasDeDetalheProps {
  textoBotaoNovo?: string;
  mostrarBotaoNovo?: boolean;
  mostrarBotaoVoltar?: boolean;
  mostrarBotaoApagar?: boolean;
  mostrarBotaoSalvar?: boolean;
  mostrarBotaoSalvarEFechar?: boolean;
  mostrarBotaoImpressao?: boolean;
  disableBotaoSalvar?: boolean;
  disableBotaoSalvarEFechar?: boolean;
  disableBotaoApagar?: boolean;
  mostrarBotaoNovoCarregando?: boolean;
  mostrarBotaoVoltarCarregando?: boolean;
  mostrarBotaoApagarCarregando?: boolean;
  mostrarBotaoSalvarCarregando?: boolean;
  mostrarBotaoSalvarEFecharCarregando?: boolean;
  mostrarBotaoImpressaoCarregando?: boolean;
  mostrarBotaoFinalizar?: boolean;
  mostrarBotaoFinalizarCarregando?: boolean;
  disableBotaoFinalizar?: boolean;
  aoClicarEmFinalizar?: () => void;
  aoClicarEmNovo?: () => void;
  aoClicarEmVoltar?: () => void;
  aoClicarEmApagar?: () => void;
  aoClicarEmSalvar?: () => void;
  aoClicarEmSalvarEFechar?: () => void;
  aoClicarEmImpressao?: () => void;
  id?: string;
  solicitante?: string;
  sx?: SxProps<Theme>;
}
export const FerramentasDeDetalheEntradaSaida: React.FC<IFerramentasDeDetalheProps> = ({
  textoBotaoNovo = "",
  mostrarBotaoNovo = true,
  mostrarBotaoVoltar = true,
  mostrarBotaoApagar = true,
  mostrarBotaoSalvar = true,
  mostrarBotaoImpressao = true,
  disableBotaoSalvar = false,
  disableBotaoSalvarEFechar = false,
  disableBotaoApagar = false,
  mostrarBotaoSalvarEFechar = false,
  mostrarBotaoNovoCarregando = false,
  mostrarBotaoVoltarCarregando = false,
  mostrarBotaoApagarCarregando = false,
  mostrarBotaoSalvarCarregando = false,
  mostrarBotaoSalvarEFecharCarregando = false,
  mostrarBotaoImpressaoCarregando = false,
  mostrarBotaoFinalizar = true,
  mostrarBotaoFinalizarCarregando = false,
  disableBotaoFinalizar = false,
  aoClicarEmFinalizar,
  aoClicarEmNovo,
  aoClicarEmVoltar,
  aoClicarEmApagar,
  aoClicarEmSalvar,
  aoClicarEmSalvarEFechar,
  aoClicarEmImpressao,
  id,
  solicitante,
  sx,
}) => {
  const smDown = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));
  const mdDown = useMediaQuery((theme: Theme) => theme.breakpoints.down("md"));
  const theme = useTheme();

  const formatDate = (date: Date) => {
    return date.toLocaleDateString('pt-BR');
  };
  const renderButton = (
    condition: boolean | undefined,
    loading: boolean | undefined,
    onClick: (() => void) | undefined,
    icon: string,
    label: string,
    color: "primary" | "secondary" | "success" | "error" | "info" | "warning",
    disabled?: boolean,
    skeletonWidth?: number
  ) => {
    if (loading) return <Skeleton width={skeletonWidth || 110} height={60} sx={{ borderRadius: 1 }} />;
    if (!condition) return null;

    return (
      <Button
        color={color}
        disableElevation
        variant="text"
        onClick={onClick}
        disabled={disabled}
        startIcon={<Icon>{icon}</Icon>}
        sx={{
          borderRadius: 1,
          px: 2,
          py: 1,
          textTransform: 'none',
          color: theme.palette.text.primary,
          '&:hover': {
            backgroundColor: alpha(theme.palette.primary.main, 0.08),
            boxShadow: 'none'
          },
          '& .MuiButton-startIcon': {
            color: theme.palette.primary.main
          }
        }}
      >
        <Typography
          variant="button"
          whiteSpace="nowrap"
          textOverflow="ellipsis"
          overflow="hidden"
          fontWeight={500}
        >
          {label}
        </Typography>
      </Button>
    );
  };
  return (
    <Box
      sx={{
        mx: 1,
        mb: 3,
        borderRadius: 3,
        marginRight: 3,
        background: `linear-gradient(135deg, ${alpha(theme.palette.primary.light, 0.05)} 0%, ${alpha(theme.palette.background.paper, 0.9)} 100%)`,
        boxShadow: theme.shadows[1],
        overflow: 'hidden',
        ...sx
      }}
    >
      <Box
        sx={{
          p: 4,
          display: 'flex',
          alignItems: 'center',
          gap: 4,
          background: 'transparent'
        }}
      >
        <Avatar
          sx={{
            backgroundColor: alpha(theme.palette.primary.main, 0.1),
            color: theme.palette.primary.main,
            width: 64,
            height: 64
          }}
        >
          <Description fontSize="large" />
        </Avatar>
        <Box>
          <Typography variant="h4" fontWeight="bold" sx={{ mb: 0.5 }}>
            Solicitação {textoBotaoNovo}
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Chip
              label={solicitante ? solicitante : 'Solicitante'}
              size="small"
              sx={{
                borderRadius: '6px',
                backgroundColor: alpha(theme.palette.primary.main, 0.1),
                color: theme.palette.primary.main,
                fontWeight: 600,
                fontSize: '0.85rem'
              }}
            />
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          px: 1,
          py: 2,
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          background: 'transparent',
          borderTop: `1px solid ${alpha(theme.palette.divider, 0.1)}`
        }}
      >
        {renderButton(
          mostrarBotaoVoltar,
          mostrarBotaoVoltarCarregando,
          aoClicarEmVoltar,
          "arrow_back",
          "Voltar",
          "primary",
          false
        )}
        {mostrarBotaoVoltar && (
          <Divider
            orientation="vertical"
            flexItem
            sx={{
              borderColor: alpha(theme.palette.divider, 0.05),
              mx: 0.5
            }}
          />
        )}
        {renderButton(
          mostrarBotaoSalvar,
          mostrarBotaoSalvarCarregando,
          aoClicarEmSalvar,
          "save",
          "Salvar",
          "primary",
          disableBotaoSalvar
        )}
        {!smDown && !mdDown && renderButton(
          mostrarBotaoSalvarEFechar,
          mostrarBotaoSalvarEFecharCarregando,
          aoClicarEmSalvarEFechar,
          "save",
          "Salvar e Fechar",
          "primary",
          disableBotaoSalvarEFechar,
          180
        )}
        {renderButton(
          mostrarBotaoApagar,
          mostrarBotaoApagarCarregando,
          aoClicarEmApagar,
          "delete",
          "Apagar",
          "error",
          disableBotaoApagar
        )}
        {!smDown && renderButton(
          mostrarBotaoNovo,
          mostrarBotaoNovoCarregando,
          aoClicarEmNovo,
          "add",
          textoBotaoNovo,
          "primary",
          false
        )}
        {renderButton(
          mostrarBotaoImpressao,
          mostrarBotaoImpressaoCarregando,
          aoClicarEmImpressao,
          "print",
          "Imprimir",
          "primary",
          false
        )}
        {renderButton(
          mostrarBotaoFinalizar,
          mostrarBotaoFinalizarCarregando,
          aoClicarEmFinalizar,
          "check_circle",
          "Finalizar",
          "success",
          disableBotaoFinalizar
        )}
      </Box>
    </Box>
  );
};